// prevents unauthenticated or unauthorized users from accessing restricted routes
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService, RouteNavigationService } from '@services/index';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private routeNavService: RouteNavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    const currentTenant = this.authenticationService.currentTenantValue;
    const subDomain = route.url[0].path;
    // logout if domain name change
    if (currentTenant) {
      if (subDomain !== currentTenant.subDomainName) {
        // Explicitly set domain name when logging out
        this.authenticationService.logout(true, subDomain);
        return false;
      }
    }

    if (
      currentUser &&
      currentTenant &&
      currentUser.tenantId === currentTenant.id
    ) {
      // check if route is restricted by role
      if (
        route.data.roles &&
        route.data.roles.indexOf(currentUser.role) === -1
      ) {
        // role not so go to dashboard
        this.routeNavService.navigate('admin/dashboard');

        return false;
      }

      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page (no need to logout)
    this.routeNavService.tenantAuthPage(state.url);

    return false;
  }
}
